import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuthContext } from "../../context/context";
import { Sidebar, Menu, MenuItem } from "react-pro-sidebar";
import BtnPrimaryM from "../Buttons/BtnPrimaryM";
import {
  TbLayoutDashboard,
  TbEye,
  TbFocus2,
  TbCalendar,
  TbHeart,
  TbLogin2,
  TbLogin,
  TbHelp,
  TbSettings,
  TbPigMoney,
} from "react-icons/tb";
import IconCircle from "../Elements/IconCircle";
import { HiOutlineChevronDoubleLeft } from "react-icons/hi";
import { useLanguage } from "../../context/LanguageContext";

export default function SidebarNav() {
  const auth = useAuthContext();
  const [collapsed, setCollapsed] = useState(false);
  const { copy } = useLanguage();
  const location = useLocation();
  const currentPath = location.pathname;

  const calculateDaysLeft = (trialEndDate) => {
    if (!trialEndDate) return 0;
    const end = new Date(trialEndDate);
    const today = new Date();
    const diffTime = end.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays > 0 ? diffDays : 0;
  };

  const handleLogout = async () => {
    try {
      auth.logout();
    } catch (error) {
      console.error("Logout failed", error);
    }
  };

  return (
    <div className="sticky top-0 h-screen w-auto flex-shrink-0 z-50">
      <div
        className="absolute right-[-14px] top-[15px] z-10"
        onClick={() => setCollapsed(!collapsed)}
      >
        <IconCircle
          icon={HiOutlineChevronDoubleLeft}
          onClick={() => setCollapsed(!collapsed)}
          className={`transform transition-transform duration-300 ${collapsed ? "rotate-180" : ""}`}
        />
      </div>

      <Sidebar
        collapsed={collapsed}
        transitionDuration={500}
        className="h-screen"
      >
        <Menu className="h-full relative">
          <div className="py-10 flex justify-center items-center">
            <Link to="/">
              <span className="transition-all duration-300 font-accent color-primary text-5xl">
                {collapsed ? "N" : "NIUMI"}
              </span>
            </Link>
          </div>

          <div
            className="flex flex-col gap-1 overflow-y-auto"
            style={{ maxHeight: "calc(100% - 220px)" }}
          >
            <MenuItem
              icon={<TbLayoutDashboard />}
              component={<Link to="/" />}
              active={currentPath === "/"}
            >
              {copy.homepage.headline}
            </MenuItem>

            <MenuItem
              icon={<TbFocus2 />}
              component={<Link to="/goals" />}
              active={currentPath.startsWith("/goals")}
            >
              {copy.goals.headline}
            </MenuItem>
            <MenuItem
              icon={<TbCalendar />}
              component={<Link to="/calendar" />}
              active={currentPath === "/calendar"}
            >
              {copy.milestones.headline}
            </MenuItem>
            <MenuItem
              icon={<TbEye />}
              component={<Link to="/vision-board" />}
              active={currentPath === "/vision-board"}
            >
              {copy.vision_board.headline}
            </MenuItem>
            <MenuItem
              icon={<TbHeart />}
              component={<Link to="/wishlist" />}
              active={currentPath === "/wishlist"}
            >
              {copy.wishlist.headline}
            </MenuItem>
            <MenuItem
              icon={<TbPigMoney />}
              component={<Link to="/finance" />}
              active={currentPath === "/finance"}
            >
              {copy.finance.headline}
            </MenuItem>

            {auth.loggedIn &&
              !collapsed &&
              auth.userData &&
              auth.userData.userType !== "influencer" &&
              auth.userData.isTrialActive &&
              !auth.userData.hasActiveSubscription && (
                <div className="card-base bg-base-gradient card-base-border w-53 self-center p-4 gap-4 flex flex-col !mt-2">
                  <div className="flex flex-col gap-2">
                    <h3>{copy.sidebar.upgrade_plan.title}</h3>
                    <p className="text-xs">
                      {copy.sidebar.upgrade_plan.description.replace(
                        "{days}",
                        calculateDaysLeft(auth.userData.trialEndDate)
                      )}
                    </p>
                  </div>
                  <BtnPrimaryM
                    buttonCTA={copy.sidebar.upgrade_plan.button}
                    onClickLink={() => (window.location.href = "/pricing")}
                  />
                </div>
              )}
          </div>

          <div className="absolute bottom-0 w-full bg-white z-10">
            <div className="flex flex-col gap-1 py-4">
              {auth.loggedIn && (
                <MenuItem
                  icon={<TbSettings />}
                  component={<Link to="/settings" />}
                  active={currentPath === "/settings"}
                >
                  {copy.sidebar.settings}
                </MenuItem>
              )}

              <MenuItem
                icon={<TbHelp />}
                component={
                  <a
                    href="https://www.niumi.dk/help-center/"
                    target="_blank"
                    rel="noopener noreferrer"
                  />
                }
                active={currentPath === "https://www.niumi.dk/help-center/"}
              >
                {copy.help_center.headline}
              </MenuItem>

              {auth.authStatus === "loading" ? (
                <></>
              ) : !auth.loggedIn ? (
                <MenuItem
                  icon={<TbLogin2 />}
                  component={<Link to="/login" />}
                  active={currentPath === "/login"}
                >
                  {copy.login.headline}
                </MenuItem>
              ) : (
                <MenuItem onClick={handleLogout} icon={<TbLogin />}>
                  {copy.logout.headline}
                </MenuItem>
              )}
            </div>
          </div>
        </Menu>
      </Sidebar>
    </div>
  );
}
